import { AuctionParams } from 'src/types';

export const EMPTY_AUCTION_PARAMS: AuctionParams = {
	auctionStartPrice: null,
	auctionEndPrice: null,
	auctionDuration: null,
};
